var _defs, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilkReplacer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottle",
    x1: 22,
    x2: 42,
    y1: 12,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAE6FD"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F59E0B",
    d: "M27 9h10v8H27z",
    rx: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDBA74",
    d: "M24 16h16v8H24z",
    rx: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bottle)",
    stroke: "#38BDF8",
    strokeWidth: 2,
    d: "M22 22h20v29c0 3-2 5-5 5H27c-3 0-5-2-5-5V22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0F2FE",
    d: "M26 31h12v17H26z",
    rx: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#38BDF8",
    d: "M27 36h10v3H27zM27 43h10v3H27z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 4,
    fill: "#FFFFFF",
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 46,
    r: 4,
    fill: "#FFFFFF",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilkReplacer);
export default __webpack_public_path__ + "static/media/milk-replacer.5da6aa27ead53edba319eead278e06ab.svg";
export { ForwardRef as ReactComponent };